"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamesStore = void 0;
var mobx_1 = require("mobx");
var login_1 = require("mobile/utils/login");
var MiniTip_1 = require("mobile/components/MiniTip");
var app_1 = require("services/page/app");
var GamesStore = (function () {
    function GamesStore(data) {
        var _this = this;
        this.formatData = function (data) {
            _this.TGamesModule = data;
        };
        this.moduleEvent = function (moduleId) { return __awaiter(_this, void 0, void 0, function () {
            var res, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, app_1.ModuleEvent({ moduleId: moduleId })];
                    case 1:
                        res = _a.sent();
                        if (res.result.code === 0) {
                            return [2, true];
                        }
                        else if (res.result.code === 3) {
                            login_1.doLogin(location.pathname + location.search);
                            return [2, false];
                        }
                        else {
                            MiniTip_1.default(res.result.msg);
                            return [2, false];
                        }
                        return [3, 3];
                    case 2:
                        err_1 = _a.sent();
                        return [2, false];
                    case 3: return [2];
                }
            });
        }); };
        this.formatData(data);
    }
    Object.defineProperty(GamesStore.prototype, "banner", {
        get: function () {
            return (this.TGamesModule &&
                this.TGamesModule.module &&
                this.TGamesModule.module.banner &&
                this.TGamesModule.module.banner.img);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GamesStore.prototype, "activeId", {
        get: function () {
            return this.TGamesModule && this.TGamesModule.module && this.TGamesModule.module.activeId;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], GamesStore.prototype, "TGamesModule", void 0);
    __decorate([
        mobx_1.computed
    ], GamesStore.prototype, "banner", null);
    __decorate([
        mobx_1.computed
    ], GamesStore.prototype, "activeId", null);
    __decorate([
        mobx_1.action
    ], GamesStore.prototype, "formatData", void 0);
    __decorate([
        mobx_1.action
    ], GamesStore.prototype, "moduleEvent", void 0);
    return GamesStore;
}());
exports.GamesStore = GamesStore;
